import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";
import { useConfigRealtime, invalidateConfigQueries } from "@/hooks/useConfigRealtime";

/**
 * Mounted once at the app root.
 *  - subscribes to admin configuration changes and refreshes them live
 *  - clears cached configuration whenever the session changes, so a
 *    logged-out snapshot is never reused for a logged-in user
 */
export default function ConfigSync() {
  const queryClient = useQueryClient();
  const { user } = useAuth();
  const prevUserId = useRef<string | null | undefined>(undefined);

  useConfigRealtime();

  useEffect(() => {
    const id = user?.id ?? null;
    if (prevUserId.current !== undefined && prevUserId.current !== id) {
      invalidateConfigQueries(queryClient);
    }
    prevUserId.current = id;
  }, [user?.id, queryClient]);

  return null;
}
